<template>
  <v-dialog v-model="showingResultDialog"
            width="90%"
            scrollable>
    <v-card dark>
      <v-card-title class="justify-end">
        <v-btn icon
               @click.prevent="closeDialog">
          <v-icon>
            fal fa-times
          </v-icon>
        </v-btn>
      </v-card-title>
      <div class="px-4">
        <v-select v-model="form.id"
                  :items="items"
                  item-value="id"
                  :item-text="itemName"
                  hide-details
                  outlined
                  @change="selectResult">
        </v-select>
      </div>
      <div class="d-flex justify-center align-center py-2">
        <v-btn icon
               large
               :disabled="!hasPreviousResult"
               @click.prevent="goPrevious">
          <v-icon>
            fal fa-arrow-square-left
          </v-icon>
        </v-btn>

        <v-btn @click.prevent="rotateThumbnail"
               small
               :disabled="!hasHorizontalThumbnail">
          Rotate
        </v-btn>

        <v-btn icon
               large
               :disabled="!hasNextResult"
               @click.prevent="goNext">
          <v-icon>
            fal fa-arrow-square-right
          </v-icon>
        </v-btn>
      </div>
      <v-divider></v-divider>
      <v-card-text class="d-flex justify-center px-2 py-2">
        <img :src="currentThumbnail"
             style="border: 1px solid rgba(0, 0, 0, 0.15);"
             alt="Full thumbnail"/>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import {mapGetters} from 'vuex';
import {find, isNull, isObject, orderBy} from 'lodash';
import {Form} from 'vform';

export default {
  name: 'email-preview-results-dialog',
  data() {
    return {
      form: new Form({
        id: this.result ? this.result.id : '',
      }),
      horizontal: false,
    }
  },
  computed: {
    ...mapGetters('emailPreviews', [
      'hasPreviousResult',
      'hasNextResult',
      'preview',
      'result',
      'results',
      'resultIndex',
    ]),
    // @see https://v3.vuex.vuejs.org/guide/forms.html#two-way-computed-property
    showingResultDialog: {
      get() {
        return this.$store.state.emailPreviews.showingResultDialog;
      },
      set(value) {
        if (value) {
          this.$store.commit('emailPreviews/setShowingResultDialog', value);
        } else {
          this.$store.commit('emailPreviews/clearResult');
        }
      }
    },
    orderedResults() {
      return orderBy(this.results, ['category', 'id'], ['asc', 'asc']);
    },
    items() {
      const items = [];
      let prev = null;
      const divider = {
        divider: true,
      };
      this.orderedResults.forEach(result => {
        const header = {
          id: result.category,
          header: result.category.toUpperCase(),
        }
        if (isNull(prev)) {
          items.push(header);
        } else if (prev !== result.category) {
          items.push(divider)
          items.push(header)
        }
        items.push(result);
        prev = result.category;
      })
      return items;
    },
    isComplete() {
      return this.result.status === 'Complete';
    },
    screenshots() {
      return this.result.screenshots;
    },
    hasDefaultThumbnail() {
      if (isObject(this.screenshots)) {
        return !!this.screenshots.default;
      }
      return false;
    },
    currentThumbnail() {
      if (this.hasHorizontalThumbnail && this.horizontal) {
        return this.horizontalThumbnail;
      }
      return this.defaultThumbnail;
    },
    defaultThumbnail() {
      if (this.hasDefaultThumbnail) {
        return this.screenshots.default;
      }
      return null;
    },
    hasHorizontalThumbnail() {
      if (isObject(this.screenshots)) {
        return !!this.screenshots.horizontal;
      }
      return false;
    },
    horizontalThumbnail() {
      if (this.hasHorizontalThumbnail) {
        return this.screenshots.horizontal;
      }
      return null;
    },
    hasFullThumbnail() {
      if (isObject(this.result)) {
        return !!this.result.full_thumbnail;
      }
      return false;
    },
    fullThumbnail() {
      if (this.hasFullThumbnail) {
        return this.result.full_thumbnail;
      }
      return null;
    },
    placeholder() {
      return 'https://placehold.com/340x190';
    },
    thumbnail() {
      if (isObject(this.result) && this.result.thumbnail) {
        return this.result.thumbnail;
      }
      return null;
    },
  },
  created() {
    this.initForm();
  },
  methods: {
    initForm() {
      console.log('initForm');
      if (this.result) {
        this.form.id = this.result.id;
        console.log('initForm', this.form.id);
      } else {
        console.log('initForm has no form ID');
      }
    },
    itemName(result) {
      return `${result.display_name} - ${result.os}`
    },
    selectResult() {
      const result = find(this.results, r => r.id === this.form.id);
      this.$store.dispatch('emailPreviews/setResult', result);
    },
    goPrevious() {
      this.$store.dispatch('emailPreviews/goPrevious');
      this.initForm();
      this.horizontal = false;
    },
    goNext() {
      this.$store.dispatch('emailPreviews/goNext');
      this.initForm();
      this.horizontal = false;
    },
    rotateThumbnail() {
      this.horizontal = !this.horizontal;
    },
    closeDialog() {
      this.$store.dispatch('emailPreviews/clearResult');
    }
  }
}
</script>
